var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseCard',{attrs:{"title":"Upgrade to Pro"}},[_c('VText',{attrs:{"gutter-bottom":""}},[_vm._v("Manage more profiles with Pro.")]),_vm._v(" "),_c('Button',{attrs:{"to":_vm.actionUrl,"size":"small"}},[_vm._v("Upgrade Now")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }